import React, { useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { I18n } from 'react-redux-i18n';

import { useAppDispatch, useAppSelector } from '../../hooks/redux/useApp';
import { mfaMethod, verifyMfaWithPasskey } from '../../modules/session';
import { isPasskeySupported } from '../../helpers/passkeys';
import { grecaptchaToken } from '../../helpers/grecaptcha';

/**
 * Offers a passkey on the MFA step when the account has one. The code form below stays as the
 * alternative.
 */
const PasskeyVerifyButton = () => {
  const dispatch = useAppDispatch();
  const pendingSessionToken = useAppSelector(
    (state) => state.session.pendingSessionToken
  );
  const mfaMethods = useAppSelector((state) => state.session.mfaMethods);
  const [busy, setBusy] = useState(false);

  if (
    !pendingSessionToken ||
    !mfaMethods?.includes(mfaMethod.passkey) ||
    !isPasskeySupported()
  ) {
    return null;
  }

  const handleClick = async () => {
    setBusy(true);
    try {
      await dispatch(
        verifyMfaWithPasskey(pendingSessionToken, () =>
          grecaptchaToken('login')
        )
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="verification-passkey">
      <Button
        type="button"
        primary
        fluid
        loading={busy}
        disabled={busy}
        onClick={handleClick}
      >
        <Icon name="key" aria-hidden="true" />
        {I18n.t('authentication.mfa.usePasskey')}
      </Button>
      <p className="verification-passkey-or">
        {I18n.t('authentication.mfa.orEnterCode')}
      </p>
    </div>
  );
};

export default PasskeyVerifyButton;
